import { render, staticRenderFns } from "./TrailerLocationFrag.vue?vue&type=template&id=fcb65446"
import script from "./TrailerLocationFrag.vue?vue&type=script&lang=js"
export * from "./TrailerLocationFrag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports